import styled from "@emotion/styled"

const Container = styled('div')(() => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    height: '1410px',
    zIndex: 1,
    background: '#f5f5f5',
}))

export default Container 
